import { Component, Input } from '@angular/core';

@Component({
  selector: 'loader-spinner',
  template:
    '<div class="loader-spinner" [ngStyle]="{minHeight: height}"><div class="lds-facebook"><mat-spinner [diameter]="60"></mat-spinner></div></div>',
  styleUrls: ['./loader.spinner.style.scss']
})
export class LoaderSpinnerComponent {
  @Input() height = '100%';
}
